import angular from 'angular';
import {v4 as uuidv4} from 'uuid';

import '../../../main/factory/authentication';
import '../../../main/factory/standalone_pos_device';
import '../../../core/main/directive/decimal/directive'
import '../../../core/main/directive/greater_than/directive'
import '../../../core/main/directive/minimum_length/directive'
import './style.scss';

document.write(require('./view.html').default);

angular.module("merchant.application.module.device.redeemBarcode", []).controller("merchant.application.module.device.redeemBarcode.controller", [
    "$rootScope", "$scope", "$controller", "$window",
    "merchant.application.main.factory.authentication",
    "merchant.application.main.factory.standalonePosDevice",
    function ($rootScope, $scope, $controller, $window, Authentication, StandalonePosDevice) {
        $controller("merchant.application.module.controller", {$scope: $scope});

        if (!$scope.model.redeemBarcode) {
            $scope.model.redeemBarcode = {};
        }

        $scope.model.currency = Authentication.currencyCode() || "AUD";
        $scope.model.orderCreated = false;
        $scope.model.currentError = null;

        $scope.deviceId = StandalonePosDevice.deviceId;

        $scope.deviceName = StandalonePosDevice.deviceName;

        $scope.storeName = StandalonePosDevice.storeName;

        $scope.submit = function () {
            if ($scope.form.$valid) {
                $scope.redeemBarcode();
            }
        };

        $scope.redeemBarcode = function () {
            var parameters = angular.copy($scope.model.redeemBarcode.data);
            parameters.amount = {
                amount: $scope.model.redeemBarcode.amount,
                currency: $scope.model.currency,
                symbol: "$"
            };
            parameters.operator = Authentication.userEmail();
            parameters.requestId = uuidv4();
            parameters.requestedAt = new Date().toISOString();

            $scope.model.currentError = null;
            $scope.model.orderCreated = false;
            StandalonePosDevice.redeemBarcode(parameters, function (response) {
                $scope.model.orderId = response.data && response.data.orderId;
                $scope.model.redeemedPreApprovalCode = response.data && response.data.preApprovalCode;
                $scope.model.orderCreated = true;
                // Clear out the form data to assist a new order submission
                $scope.model.redeemBarcode.data = {};
                $scope.model.redeemBarcode.amount = "";
                $scope.form.$setPristine();
            }, function (error) {
                $scope.model.currentError = error.data && error.data.errorCode;
                if (error.status === 429) {
                    // PAYL-6333 The BE doesn't return an error code when rate limiting occurs
                    $scope.model.currentError = "too_many_requests";
                }
            });
        };

        $scope.loginErrorHandler = function (error) {
            if (error && error.status === 401) {
                // Suppress the global error handler as an unauthenticated POS user is returned as a 401
                $rootScope.unauthorisedError = false;
                $window.location.href = StandalonePosDevice.posUserAuthorizationUrl({countryCode: Authentication.countryCode()});
            } else {
                $scope.model.currentError = error.data && error.data.errorCode;
            }
        };

        $scope.tokenErrorHandler = function (error) {
            $scope.model.currentError = error.data && error.data.errorCode;
        };

        $scope.model.currentError = null;

        StandalonePosDevice.init($scope.tokenErrorHandler, $scope.loginErrorHandler);

    }
]);
